import FormValidator from './FormValidator';
import AsyncRequest from '../classes/AsyncRequest';
import User from '../classes/User';
import EventNames from '../constants/DataLayer/EventNames';

export default class LoginValidator extends FormValidator {
  errorMessage: ?HTMLElement;
  emailElement: HTMLInputElement;
  passwordElement: HTMLInputElement;
  type: string = '';

  /**
   * @inheritDoc
   */
  bind(pEl: HTMLElement): void {
    super.bind(pEl);

    this.errorMessage = this.el.getElementByRef('error-message');

    const emailElement: ?HTMLElement = this.el.getElementByRef('email');
    if (!emailElement) {
      throw new Error('email input is required!');
    }
    this.emailElement = emailElement;

    const passportElement: ?HTMLElement = this.el.getElementByRef('input');
    if (!passportElement) {
      throw new Error('password input is required!');
    }
    this.passwordElement = passportElement;

    if (this.el.getElementByRef('type')) {
      this.type = this.el.getElementByRef('type').value;
    }

    if (!localStorage.getItem('loginAttempts')) {
      localStorage.setItem('loginAttempts', 1);
    }
  }

  async onSubmit(event?: Event): Promise<boolean> {
    event?.preventDefault();
    if (!(await super.validate())) {
      this.sendLoginFailedEvent({ reason: 'invalid_email' });
      return false;
    }
    this.submit();
    return true;
  }

  /**
   * @inheritDoc
   */
  async submit() {
    const { data } = await AsyncRequest.post('', {
      email: this.emailElement.value,
      password: this.passwordElement.value
    }, '/login');

    if (!data.authenticated && this.type === 'checkout') {
      this.sendLoginFailedEvent(data);
      User.notifyFail(window.store.getTranslation('login.error.message'));
      this.passwordElement.value = '';
      return;
    }

    if (!data.authenticated) {
      this.sendLoginFailedEvent(data);
      this.passwordElement.value = '';
      if (this.errorMessage) {
        this.errorMessage.classList.remove('hidden');
      }
      return;
    }

    this.dispatch({ event: EventNames.LOGIN, GA4: true });
    localStorage.setItem('loginAttempts', 1);

    location.reload();
  }

  sendLoginFailedEvent(data): void {
    this.dispatch({
      event: EventNames.LOGIN_FAILED,
      data: {
        reason: data.reason,
        attempts: +localStorage.getItem('loginAttempts')
      },
      GA4: true
    });
    localStorage.setItem('loginAttempts', +localStorage.getItem('loginAttempts') + 1);
  }
}
